export const IS_JEST = process && process.env ? process.env.JEST_WORKER_ID !== undefined : false;
